import {
  RER_INVALIDATE_PAGE,
  RER_INVALIDATE_PAGE_RESET,
} from 'rer-theme/constants/ActionTypes';

export function invalidatePage(path) {
  return {
    type: RER_INVALIDATE_PAGE,
    request: {
      op: 'post',
      path,
    },
  };
}

export function invalidatePageReset(path) {
  return {
    type: RER_INVALIDATE_PAGE_RESET,
  };
}
